"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceVariable = function (string, value, name) {
    return string.replace(variableRegExp(name), value);
};
function variableRegExp(variable) {
    return new RegExp("\\{\\s*variables\\." + variable + "\\s*\\}", 'g');
}
//# sourceMappingURL=replace-variable.js.map